import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./adiantamento-listar/adiantamento-listar.module').then(m => m.AdiantamentoListarModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./adiantamento-editar/adiantamento-editar.module').then(m => m.AdiantamentoEditarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./adiantamento-inserir/adiantamento-inserir.module').then(m => m.AdiantamentoInserirModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./adiantamento-detalhar/adiantamento-detalhar.module').then(m => m.AdiantamentoDetalharModule) }

  ])],
  exports: [RouterModule]
})
export class AdiantamentoRoutingModule { }
